import React from 'react';
import PropTypes from 'prop-types';
import { hex2ascii, LedgerEntryType } from '../../common/Helpers';

const Credential = (props) => {
    const { node } = props;
    if ( node?.LedgerEntryType === LedgerEntryType.Credential ) {
        return (
            <>
                {node?.Subject &&
                <tr>
                    <td>Subject:</td>
                    <td>
                        <span>
                            {node.Subject}
                        </span>
                    </td>
                </tr>
                }
                {node?.CredentialType &&
                <tr>
                    <td>CredentialType:</td>
                    <td>
                        <span>
                            {hex2ascii(node.CredentialType)}
                        </span>
                    </td>
                </tr>
                }
            </>
        );    
    } else {
        return <></>;
    }
}

Credential.propTypes = {
    node: PropTypes.object,
}

export default Credential;